const data = {
    PENDING: 1,
    CANCELLED: 2,
    FINISHED: 3,
    IN_PROGRESS: 4,
    CONFIRMED: 5,
};

export default { ...data };